import React, { ReactElement } from "react";
import { CircularProgressbarWithChildren } from "react-circular-progressbar";
import { SUCCESS_SVG } from "../../utils/svgs";
import { AppBottomSheet, AppBottomSheetProps } from "../Generic/AppBottomSheet";
import { AppButton } from "../Generic/AppButton";
import { AppIcon } from "../Generic/AppIcon";
import { AppOverlay } from "../Generic/AppOverlay";
import { useInterval } from "./TrainingCenterVideoPlayer/Utils";

interface Props extends AppBottomSheetProps {
  isOpen: boolean;
  header: string;
  description: string;
  loadingTime: number;
  buttonText: string;
  onRequestClose: () => void;
}

const circularProgressbarStyles = {
  background: {
    fill: "#89CCF8",
  },
  trail: {
    stroke: "#BEE6FF",
  },
  path: {
    stroke: "#0A77E6",
  },
};

export function TrainingCenterBundleItemSuccess(props: Props): ReactElement {
  const [timeLeft, setTimeLeft] = React.useState(0);

  useInterval(() => {
    if (timeLeft < props.loadingTime) {
      setTimeLeft((time) => time + 1);
    }
  }, 1000);

  return (
    <AppOverlay>
      <AppBottomSheet {...props} className="TrainingCenterBundleItemSuccess">
        <div className="TrainingCenterBundleItemSuccess__countdown">
          <CircularProgressbarWithChildren
            value={props.loadingTime - timeLeft}
            maxValue={props.loadingTime}
            strokeWidth={8}
            background={true}
            styles={circularProgressbarStyles}
          >
            <AppIcon icon={SUCCESS_SVG} size={60} />
          </CircularProgressbarWithChildren>
        </div>
        <h2 className="TrainingCenterBundleItemSuccess__header">{props.header}</h2>
        <p className="TrainingCenterBundleItemSuccess__description">{props.description}</p>
        <AppButton
          onClick={props.onRequestClose}
          style={{ flexGrow: 1, backgroundColor: "#0A77E6" }}
        >
          {props.buttonText}
        </AppButton>
      </AppBottomSheet>
    </AppOverlay>
  );
}
